<mat-dialog-content>
  <section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
      <div class="d-grid grid-columns-top-3">
        <div class="accounts">
          <ul>
            <li>Search From Reservations by Date</li>

          </ul>
        </div>
        <!-- <div class="search">
          <form method="get">
            <input id="search" name="searchDate" type="text" [(ngModel)]="resDate" (change)="retriveResLookup()"
              placeholder="Doctor Code">
            <label>                      </label>
            <input id="search" name="search" type="text" [(ngModel)]="patientName" (change)="retriveResLookup()"
              placeholder="Doctor Name">

          </form>
        </div> -->
      </div>
    </div>
  </section>

  <table>
    <thead>
      <tr>
        <th style="width: 10%;">Patient Code</th>
        <th style="width: 40%;">Patient Name</th>
        <th style="width: 40%;">Doctor Name</th>
        <th style="width: 10%;">Choose</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let Do of ResrvationList; let i = index">
        <td data-column="Doctor ID">{{Do.patientCode}}</td>
        <td data-column="Doctor Name">{{Do.patientName}}</td>
        <td data-column="Doctor Name">{{Do.resDocName}}</td>

        <td data-column="Choose"><button type="button" class="theme-button btn" id="select" name="select"
            (click)="SelectDoctors(Do)">Select</button>
        </td>
      </tr>

    </tbody>
  </table>
</mat-dialog-content>

